import { ContractPathsEnum } from '../routes';

export enum ContractsTabKeys {
  Active = 'active-contracts',
  Concluded = 'concluded-contracts',
}

export enum ContractGroup {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ALL = 'all',
}

export enum ContractCurrency {
  EURO = 'EUR',
}

export const getContractsPageUrl = (tab: ContractsTabKeys) =>
  `${ContractPathsEnum.contracts}/${tab}`;
